import { render, staticRenderFns } from "./AddTemplate.vue?vue&type=template&id=c5d2459a"
import script from "./AddTemplate.vue?vue&type=script&lang=js"
export * from "./AddTemplate.vue?vue&type=script&lang=js"
import style0 from "./AddTemplate.vue?vue&type=style&index=0&id=c5d2459a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports